import { call, put, takeEvery } from "redux-saga/effects"
import { MESSAGE_LOAD } from "./actionTypes"
import { messageError, loadMessages } from "./actions"
import service from "../../../api/type.service"

function* loadMessage(concept) {

  try {
    const response = yield call(service.getTypesByConceptCode, concept.payload)
     yield put(loadMessages(response?.data))


  } catch (error) {
    yield put(messageError(error.message))
  }
}


function* messageSaga() {
  yield takeEvery(MESSAGE_LOAD, loadMessage)

}

export default messageSaga
